<template>
    <div class="dashboard-wrap">
        <div>
            <el-row :gutter="20">
                <el-col :md="6" :sm="12" v-for="(item,index) in infoBox" class="info-wrap" :key="index">
                    <div class="info-box">
                        <span :class="'info-box-icon info-box-icon-'+item.color"><i :class="item.icon"></i></span>
                        <div class="info-box-count">
                            <span class="number">{{item.num}}</span>
                            <span>{{item.text}}</span>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </div>
        <el-row :gutter="20">
            <el-col :sm="16"><div class="chart-part" id="myChart" style="height: 400px;background: #fff"></div></el-col>
            <el-col :sm="8">
                <el-card class="box-card" style="height:420px">
                    <div slot="header" class="clearfix">
                        <span>todo</span>
                    </div>
                    <div>
                        <el-input v-model="inputTodo"><el-button slot="append" @click="addTodo">ADD</el-button></el-input>
                        <div  v-for="item in todoList" class="todo-list" :class="{'todo-list-checked':item.state}">
                            <el-checkbox v-model="item.state">{{item.text}}</el-checkbox>

                        </div>
                    </div>
                </el-card>
            </el-col>
        </el-row>
        <el-row :gutter="20">
            <el-col :sm="12">
                <el-card class="box-card">
                    <div id="myChart1" class="chart-part" style="height: 400px"></div>
                </el-card>
            </el-col>
            <el-col :sm="12">
                    <el-card class="box-card" style="height: 480px">
                        <div slot="header" class="clearfix">
                            <span>进程</span>
                        </div>
                        <el-alert
                                title="Keep me where the light is. Keep me where the light is."
                                type="success">
                        </el-alert>
                        <el-alert
                                title="Keep me where the light is. Keep me where the light is."
                                type="info">
                        </el-alert>
                        <el-row>
                            <el-col>
                                <el-progress type="circle" :percentage="0"></el-progress>
                                <el-progress type="circle" :percentage="25" color="#4b79bb"></el-progress>
                                <el-progress type="circle" :percentage="100" status="success"></el-progress>
                                <el-progress type="circle" :percentage="50" status="exception"></el-progress>
                            </el-col>
                        </el-row>
                        <el-alert
                                title="Keep me where the light is. Keep me where the light is."
                                type="warning">
                        </el-alert>
                        <el-alert
                                title="Keep me where the light is. Keep me where the light is."
                                type="error">
                        </el-alert>
                    </el-card>
            </el-col>
        </el-row>

    </div>
</template>

<script>
    const xAxisData = ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun','Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'];
    export default{
        data(){
            return {
                infoBox:[{
                    color:'yellow',
                    icon:'el-icon-search',
                    text:'User',
                    num:'12389'
                },{
                    color:'green',
                    icon:'el-icon-sold-out',
                    text:'User',
                    num:'12389'
                },{
                    color:'red',
                    icon:'el-icon-message',
                    text:'User',
                    num:'12389'
                },{
                    color:'blue',
                    icon:'el-icon-service',
                    text:'User',
                    num:'12389'
                }],
                todoList:[{
                    state:true,
                    text:'Plan weekend outing.'
                },{
                    state:false,
                    text:'Plan weekend outing.'
                },{
                    state:true,
                    text:'Plan weekend outing.'
                },{
                    state:false,
                    text:'Plan weekend outing.'
                },{
                    state:true,
                    text:'Plan weekend outing.'
                }],
                inputTodo:'',
                checked:''
            }
        },
        mounted(){
            let myChart = this.$echarts.init(document.getElementById('myChart'),'macarons')
            let myChart1 = this.$echarts.init(document.getElementById('myChart1'),'macarons')
            let option1 = {
                    tooltip: {
                        trigger: 'item',
                        formatter: '{a} <br/>{b} : {c} ({d}%)'
                    },
                    legend: {
                        left: 'center',
                        bottom: '10',
                        data: [
                            'Battlefield',
                            'Call Of Duty',
                            'Counter Strike',
                            'Splatoon',
                            'Titanfall'
                        ]
                    },
                    calculable: true,
                    series: [
                        {
                            name: 'FPS GAME DATA',
                            type: 'pie',
                            roseType: 'radius',
                            radius: [15, 140],
                            center: ['50%', '38%'],
                            data: [
                                { value: 320, name: 'Battlefield' },
                                { value: 240, name: 'Call Of Duty' },
                                { value: 149, name: 'Counter Strike' },
                                { value: 400, name: 'Titanfall' },
                                { value: 524, name: 'Splatoon' }
                            ],
                            animationEasing: 'cubicInOut',
                            animationDuration: 2600
                        }
                    ]
            };
            let option = {
                xAxis: {
                    data: xAxisData,
                    type:'category',
                    nameRotate:180
                },
                grid: {
                    left: 10,
                    right: 10,
                    bottom: 20,
                    top: 30,
                    containLabel: true
                },
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross'
                    },
                    padding: [5, 10]
                },
                yAxis: {
                    axisTick: {
                        show: false
                    }
                },
                legend: {
                    data: ['PS4 Player', 'NS Player']
                },
                series: [
                    {
                        name: 'PS4 Player',
                        smooth: true,
                        type: 'line',
                        data: [4352, 3120, 2561, 3234, 4305, 3170, 2165, 3120, 2561, 3234, 4305, 3170, 2165,3170],
                        animationDuration: 2800,
                        animationEasing: 'cubicInOut'
                    },
                ],
            }
            myChart.setOption(option)
            myChart1.setOption(option1);
            let _this =this;
            window.addEventListener('resize',function () {
                myChart.resize();
                myChart1.resize();
                if(document.body.clientWidth<=775){
                    _this.$store.commit('NAV_COLLAPSE',true)
                }else{
                    _this.$store.commit('NAV_COLLAPSE',_this.$store.state.navData.navIsCollapse)
                }
            })
        },
        methods:{
            addTodo(){
                this.todoList.push({
                    state:false,
                    text:this.inputTodo
                });
                this.inputTodo = ''
            }
        }
    }
</script>

<style  lang="scss" rel="stylesheet/scss">
    .dashboard-wrap{
        padding: 10px;
        background: #eeeeee;
        .info-wrap{
            margin-bottom: 20px;
        }
        .info-box{
            background: #ffffff;
            &-icon{
                float: left;
                width: 90px;
                display: block;
                height: 90px;
                font-size: 45px;
                text-align: center;
                line-height: 90px;
                color: #ffffff;
            }
            &-icon-yellow{
                background: #f7c94d;
            }
            &-icon-blue{
                background: #9ab7e0;
            }
            &-icon-red{
                background: #e45f5f;
            }
            &-icon-green{
                background: #41b883;
            }
            &-count{
                margin-left: 90px;
                padding:13px 10px;
                text-align: center;
                span{
                    display: block;
                }
                .number{
                    font-size: 30px;
                }
            }
        }
        .chart-part{
            height: 400px;
            background: #ffffff;
            margin-bottom: 20px;
            padding: 10px;
        }
        .el-alert{
            margin-bottom: 20px;
        }
        .todo-list{
            margin: 10px 0;
        }

        .el-checkbox__input.is-checked .el-checkbox__inner, .el-checkbox__input.is-indeterminate .el-checkbox__inner {
            background-color: #41b883!important;
            border-color: #41b883;
        }
        .todo-list-checked .el-checkbox__label{
            text-decoration: line-through;
            color:#41b883;

        }
    }

</style>


// WEBPACK FOOTER //
// src/views/dashboard/dashboard.vue